import stylesheet from './Grid.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export class NXTGrid extends CustomComponent {
    static observedAttributes = ['columns'];

    private grid: HTMLElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    // noinspection JSUnusedGlobalSymbols
    attributeChangedCallback() {
        this.applyColumns();
    }

    private applyColumns() {
        if (!this.grid) {
            return;
        }
        const columns = this.getAttribute('columns');
        this.grid.style.gridTemplateColumns = columns ? `repeat(${columns}, 1fr)` : '';
    }

    render() {
        this.grid = document.createElement('div');
        this.grid.classList.add('grid');
        this.grid.innerHTML = `<slot></slot>`;
        this.applyColumns();
        return this.grid;
    }
}

customElements.define('nxt-grid', NXTGrid);
